// extracted by mini-css-extract-plugin
export default {"tableContainer":"MyPost_tableContainer__7iqi9"};